export const landingPage = {
  section: {
    default: {
      backgroundColor: 'background',
      minHeight: '60px',
    },
    primary: {
      variant: 'landingPage.section.default',
      backgroundColor: 'primary',
    },
  },
  sectionContent: {
    default: {
      margin: '0 auto',
      maxWidth: 'sectionContentMax',
      width: ['90%', '90%', '90%', '70%'],
      py: [3, 4],
    },
  },
};
